<template>
  <div class="planDetailPage">
    <StickyTop />
    <Banner zoomWay="click" :slideList="slideList" :dblclickImage="dblclickImage" />
    <div class="planInfoList">
      <h3>{{ detailData?.productName }}</h3>
      <p v-if="detailData.ctag" class="planTag" style="margin-bottom:5px;">{{ detailData?.ctag }}</p>
      <p class="preViewFlag themeRed">这是一个预览页面</p>
    </div>
    <div class="dealerInfoList">
      <van-row class="label">
        <van-col span="8">车辆：</van-col>
        <van-col span="16">XXXXXXXX</van-col>
      </van-row>
      <van-row class="label" v-if="salesAttributesTxt !== false">
        <van-col span="8">选择：</van-col>
        <van-col span="16" @click="selectSalesAttributes"
          ><span class="fvlr salesAttribute">
            <span>{{ salesAttributesTxt }}</span>
            <van-icon name="arrow" /> </span
        ></van-col>
      </van-row>
      <van-row class="label">
        <van-col span="8">销售经销商：</van-col>
        <van-col span="16">XXXXXXXX</van-col>
      </van-row>
      <van-row class="label">
        <van-col span="8">使用/服务范围:</van-col>
        <van-col span="16">XXXXXXXX</van-col>
      </van-row>
    </div>
    <SkuImg :datas="skuAloneData" />
    <!-- 底部按钮栏目 -->
    <GoodsBar :isEnterShoppingCar="isEnterShoppingCar" :isEnable="isEnable" from="shopDetail" @clickGoodBtn="clickGoodBtn">
      <ConfirmShop
        @viewContract="viewContractServiceDealHandle"
        :datas="{ shopInfoDatas, preView: true, sign: 'ewProduct' }"
        :showTyreNum="showShopNum"
        :from="confirmTyreFrom"
        :type="confirmTyreType"
      />
    </GoodsBar>
    <ContractServiceDeal :showPopUp="showPopUp" :datas="contractData" />
  </div>
</template>

<script>
import moment from 'moment'
import { reactive, toRefs, onMounted, onUnmounted, computed, nextTick } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'

import Banner from '@/components/common/Banner'
import GoodsBar from '@/components/common/GoodsBar'
import ContractServiceDeal from '@/components/directSales/ContractServiceDeal'
import ConfirmShop from '@/components/shop/ConfirmShop'
import SkuImg from '@/components/shop/SkuImg.vue'
import StickyTop from '@/components/shop/StickyTop.vue'
import useContractServiceDealFn from '@/hooks/directSales/useContractServiceDeal'
import useEWViewDetail from '@/hooks/directSales/useEWViewDetail'
import { showToast } from '@/util/couponCollection'
import { empty } from '@/util/serviceContract'

export default {
  name: 'ewShopPreView',
  components: {
    Banner,
    GoodsBar,
    ConfirmShop,
    StickyTop,
    SkuImg,
    ContractServiceDeal
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const { viewEWContractServiceDealFn, showPopUp, contractData } = useContractServiceDealFn()

    const {
      getShopDetailFn,
      salesAttributesTxt,
      slideList,
      dblclickImage,
      detailData,
      isEnterShoppingCar,
      isEnable,
      shopInfoDatas,
      selectShopVariantItem
    } = useEWViewDetail()
    const { spuId } = route.query
    store.commit('SETSkUITEM', {})
    store.commit('SETSTEPPEROPTION', {})
    const state = reactive({
      confirmTyreFrom: '', //详情页/购物车/属性选择
      confirmTyreType: '', //立即购买/加入购物车
      showShopNum: 0
    })

    onUnmounted(() => {
      store.commit('SETSPUID', '')
    })

    const selectSalesAttributes = () => {
      clickGoodBtn({ type: 'selectAttribut', from: 'shopDetail' })
    }
    const clickGoodBtn = data => {
      if (['selectAttribut', 'bugNow', 'addShoppingCar'].includes(data.type)) {
        state.confirmTyreFrom = data.from
        state.confirmTyreType = data.type
        nextTick(() => {
          state.showShopNum += 1
        })
      }
      if (data.type == 'toShoppingCar') {
        router.push({ path: '/shoppingCar', query: { event: '查看购物车' } })
      }
    }

    const skuAloneData = computed(() => {
      const skuItem = store.state.skuItem
      const detailPics = detailData.value?.detailPics || []
      const skuPics = (skuItem.detailPics?.length && skuItem.detailPics) || detailPics
      return { ...skuItem, skuPics }
    })

    onMounted(async () => {
      await getShopDetailFn({ spuId })
    })
    const viewContractServiceDealHandle = data => {
      const skuId = data?.id || ''
      if (!skuId) {
        showToast('请先选择一个商品后预览告知书')
        return
      }
      const notifications = {
        fin: 'XXXXXXXXXXXXXXXXXX',
        contactName: 'XXXX',
        // 接口这个字段返回为null, 导致扫码进来不能查看告知书
        isWpProduct: 'XXX',
        day: moment().date(),
        month: moment().month() + 1,
        year: moment().year(),
        validPeriod: data.validPeriod,
        maxPurchaseMile: data.maxPurchaseMile,
        notificationFile: data.notificationPics,
        notificationName: data.notification,
        isShowMark: true,
        markMessage: '这是一个预览页',
        startDate: empty(20),
        endDate: empty(20),
        sign: 'ewProduct',
        productType: data.productType
      }
      viewEWContractServiceDealFn(notifications)
    }

    return {
      ...toRefs(state),
      skuAloneData,
      salesAttributesTxt,
      selectShopVariantItem,
      shopInfoDatas,
      getShopDetailFn,
      clickGoodBtn,
      slideList,
      dblclickImage,
      detailData,
      isEnterShoppingCar,
      isEnable,
      selectSalesAttributes,
      showPopUp,
      contractData,
      viewContractServiceDealHandle
    }
  }
}
</script>

<style lang="scss" scoped>
.planDetailPage {
  background-color: #f5f5f5;
  text-align: left;
  padding-bottom: calc(100px + constant(safe-area-inset-bottom));
  padding-bottom: calc(100px + env(safe-area-inset-bottom));
  .planInfoList {
    padding: 12px 20px;
    background-color: #fff;
    margin-bottom: 8px;
  }
  .dealerInfoList {
    padding: 18px 20px 10px;
    background-color: #fff;
  }
}
.planDetailPage::-webkit-scrollbar {
  display: none;
}
// 计划信息样式
.planInfoList {
  position: relative;
  h3 {
    font-size: 18px;
    color: #333;
    font-weight: 700;
    margin-bottom: 12px;
    margin-top: 10px;
  }
}

// 经销商样式
.dealerInfoList {
  .label {
    margin-bottom: 8px;
    font-size: 14px;
    color: #333;
    line-height: 18px;
  }
}

.salesAttribute {
  border-bottom: 1px solid #ccc;
  font-style: oblique;
}
.preViewFlag {
  position: absolute;
  right: 10px;
  top: 5px;
  text-align: right;
}
</style>
